// Versión de medios: obliga a los teléfonos a ignorar copias viejas/corruptas en caché.
export const withV = (url) => {
  if (!url || typeof url !== "string" || !url.includes("/api/files/")) return url;
  const [base, hash] = url.split("#");
  const out = base + (base.includes("?") ? "&" : "?") + "v=3";
  return hash ? `${out}#${hash}` : out;
};
